export default "__VITE_ASSET__CY1P5G0p__"